import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';
import { environment } from '../../environments/environment';
var AddressValidationService = /** @class */ (function () {
    function AddressValidationService(_http, _decimalPipe, _errorHandler) {
        this._http = _http;
        this._decimalPipe = _decimalPipe;
        this._errorHandler = _errorHandler;
    }
    AddressValidationService.prototype.checkAddress = function (requestBody) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var GOOGLE_URL;
            return tslib_1.__generator(this, function (_a) {
                GOOGLE_URL = "https://addressvalidation.googleapis.com/v1:validateAddress?key=" + environment.googleApiKey;
                return [2 /*return*/, this._http
                        .post(GOOGLE_URL, requestBody)
                        .toPromise()];
            });
        });
    };
    return AddressValidationService;
}());
export { AddressValidationService };
